import { yupResolver } from "@hookform/resolvers/yup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Divider } from "@mui/material";
import { Button as MUIButton } from "@mui/material";
import { useAppDispatch } from "app/hooks";
import { getAuthActionState } from "app/reducers/authSlice";
import { sendResetPasswordEmail } from "app/thunks/authAPI";
import classNames from "classnames";
import { NAVIGATOR } from "features/navigation/index";
import { ResetData } from "interfaces/requests/Auth";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Spinner, UserIcon } from "ui";
import { BUTTON_STYLES, BUTTON_TYPES } from "ui/Button";
import { TextField } from "ui/TextField";

import { validationResetPasswordSchema } from "./validations";

export const ResetPasswordScreen = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isLoading } = useSelector(getAuthActionState);

  const {
    handleSubmit,
    formState: { errors, isValid },
    register,
  } = useForm<ResetData>({
    mode: "onTouched",
    defaultValues: {
      email: undefined,
    },
    resolver: yupResolver(validationResetPasswordSchema),
  });

  const onSubmit = async (data: ResetData) => {
    try {
      await dispatch(sendResetPasswordEmail(data)).unwrap();
      history.push(NAVIGATOR.resetPasswordInstructionsSent);
    } catch (error) {
      history.push(NAVIGATOR.resetPasswordError);
      console.log(error);
    }
  };
  return (
    <div className="flex flex-col max-w-xl px-8 pl-36">
      <Link
        to="/sign-in"
        className="font-semibold text-primary hover:text-[#2ED2CD] text-xl flex items-center gap-2"
      >
        <ArrowBackIcon />
        Back
      </Link>
      <div className="mb-8">
        <h1 className="text-white text-3xl mt-10 font-semibold font-orbitron">
          Resetea tu contraseña
        </h1>
        <p className="text-white text-base mt-2 font-inter">
          Ingresa el Email asociado con tu cuenta. Enviaremos un email con las
          instrucciones para resetear tu contraseña.
        </p>
      </div>
      <Divider className="bg-gray-300" />
      <div className="flex flex-col mt-10 gap-2">
        <TextField
          type="text"
          placeholder="Nombre de usuario"
          {...register("email")}
          name="email"
          errorMessage={errors.email?.message}
          label="Nombre de Usuario"
          startAdornment={<UserIcon />}
        />
        <MUIButton
          variant="contained"
          disabled={!isValid || isLoading}
          onClick={handleSubmit(onSubmit)}
          className={classNames(
            BUTTON_STYLES[BUTTON_TYPES.SPACE_AUTH],
            "w-full",
          )}
        >
          {isLoading ? <Spinner color="white" /> : <p>Enviar instrucciones</p>}
        </MUIButton>
      </div>
    </div>
  );
};
